import React from "react";
import _ from "lodash";

import { connect } from "react-redux";

const Footer = ({
  parameters,
  current_round,
  total_rounds,
  join_code,
  onEndGame,
  onTimesUp,
  status,
}) => {
  const end_game = _.get(parameters, "end_game", "End Game");
  console.log(end_game, "end_game==>");
  const round = _.get(parameters, "round", "Round");
  const join_code_text = _.get(parameters, "join_code", "Join Code");
  const times_up = _.get(parameters, "times_up", "Times Up");

  return (
    <div className="footer">
      <button className="btn end-game-btn" onClick={onEndGame}>
        {end_game}
      </button>
      {status === "Over" && (
        <button
          className="btn times-up-btn"
          onClick={onTimesUp}
          disabled={true}
        >
          {times_up}
        </button>
      )}
      {status !== "Over" && (
        <button className="btn end-game-btn" onClick={onEndGame}>
          {end_game}
        </button>
      )}
      {status !== "Over" && (
        <button
          className="btn times-up-btn"
          disabled={status === "Over"}
          onClick={onTimesUp}
        >
          {times_up}
        </button>
      )}
      {current_round < 10 ? (
        <p className="round-btn2">
          {round} <br />
          <span>
            {current_round}/{total_rounds}
          </span>
        </p>
      ) : (
        <p className="round-btn2">
          {round} <br />
          <span>
            {current_round}/{total_rounds}
          </span>
        </p>
      )}{" "}
      <p className="join-code-btn">
        {join_code_text} <br />
        <span>{join_code}</span>
      </p>
    </div>
  );
};

export default Footer;
